import React from 'react';

export default function Footer() {
  return (
    <>
      <footer className="footer">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-3 separator-right">
              <div className="navigation-footer">
                <ul id="menu-footer" className="footer-links clearfix">
                  <li><a href="https://www.ovatures.com/who-are-we">Who are we?</a></li>
                  <li><a href="https://www.ovatures.com/why-donate">Why donate?</a></li>
                  <li><a href="https://www.ovatures.com/the-process">The process</a></li>
                  <li><a href="https://www.ovatures.com/about-us/">About Us</a></li>
                  <li><a href="https://www.ovatures.com/faqs">FAQs</a></li>
                  <li><a href="https://www.ovatures.com/blog">Blog</a></li>
                  <li><a href="https://www.ovatures.com/contact-us">Contact Us</a></li>
                </ul>
              </div>
            </div>
            <div className="col-md-5 col-lg-4 footer-logo">
              <a href="https://ivirma.com" target="_blank" rel="noopener noreferrer">
                <img src="/images/logo-ivi-rma-global.png" alt="IVI RMA Global" />
              </a>
            </div>
            <div className="col-md-3 separator-left">
              <div className="social-media-footer">
                <ul id="social-menu-menu" className="social-media clearfix">
                  <li>
                    <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/ovatures">
                      Twitter
                    </a>
                  </li>
                  <li>
                    <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/Ovatures/">
                      Facebook
                    </a>
                  </li>
                  <li>
                    <a target="_blank" rel="noopener noreferrer" href="https://instagram.com/ovatures">
                      Instagram
                    </a>
                  </li>
                </ul>
              </div>
              <div className="contact">
                <span className="title">Contact</span>
                <span className="phone-number">973 656 2876</span>
                <span className="email">
                  <a href="mailto:ovatures@ivirma.com">ovatures@ivirma.com</a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="copyright">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <div className="text">
                &copy; 2025 Ovatures. All rights reserved.{' '}
                <a target="_blank" rel="noopener noreferrer" href="/docs/NOTICE-OF-PRIVACY-PRACTICES_9.23.13.pdf">
                  Legal Notice
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
